import styled from "styled-components";

export const TextareaWrapper = styled.section`
	margin-bottom: 25px;
`;

export const TextareaContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px 0;
`;

export const TextareaInput = styled.textarea`
  border: 1px solid #e8e8e8;
  width: 100%;
  height: 110px;
  border-radius: 3px;
  margin-bottom: 5px;
  padding: 8px;
  font-size: 13px;
  line-height: 1.3;
  font-weight: 400;
  color: #3e3e3e;
  resize: none;

  :focus {
    outline: none;
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
  }
`;

export const CharacterSpan = styled.span`
  text-align: end;
  font-size: 10px;
  font-weight: 400;
  color: #4a4a4a;
`;

export const UsageMessage = styled.p`
  font-size: 10px;
  line-height: 1.3;
  font-weight: 400;
  color: #4a4a4a;
`;

export const PageTitle = styled.span`
  font-size: 10px;
  font-weight: 400;
  font-family: "Courier New", Courier, monospace;
  color: #50aff4;
`;

export const SvgCopy = styled.svg`
  :hover {
    cursor: pointer;
  }
`;
